/* eslint-disable */

// namespace MJPEG { ...
var MJPEG = (function(module) {
  "use strict";

  // class Stream { ...
  module.Stream = function(args) {
    var self = this;
    var autoStart = args.autoStart || false;

    self.url = args.url;
    self.refreshRate = args.refreshRate || 50;
    self.onStart = args.onStart || null;
    self.onFrame = args.onFrame || null;
    self.onStop = args.onStop || null;
    self.callbacks = {};
    self.running = false;
    self.frameTimer = 0;

    self.img = new Image();
    // self.img.setAttribute('crossOrigin', 'use-credentials');
    self.img.setAttribute('crossOrigin', '');
    if (autoStart) {
      self.img.onload = self.start;
    }
    self.img.src = self.url;
    
    function setRunning(running) {
      self.running = running;
      if (self.running) {
        self.img.src = self.url;
        self.frameTimer = setInterval(function() {
          if (self.onFrame) {
            self.onFrame(self.img);
          }
        }, self.refreshRate);
        if (self.onStart) {
          self.onStart();
        }
      } else {
        self.img.src = "#";
        clearInterval(self.frameTimer);
        if (self.onStop) {
          self.onStop();
        }
      }
    }

    self.start = function() { setRunning(true); }
    self.stop = function() { setRunning(false); }
  };

  // class Player { ...
  module.Player = function(url, options) {

    var self = this;

    if (! options) {
      options = {};
    }
    options.url = url;
    options.onFrame = updateFrame;
    options.onStart = function() { console.log("started"); }
    options.onStop = function() { console.log("stopped"); }

    self.stream = new module.Stream(options);
    function setContext(canvas) {
      if (typeof canvas === "string" || canvas instanceof String) {
        canvas = document.getElementById(canvas);
      }
      self.context = canvas.getContext("2d");
      // self.context = canvas;
    }
    let preT = new Date().getTime();

    function updateFrame(img) {
      try {
        self.context.drawImage(img,
          0,0, 480, 360
        );
        const t = new Date().getTime();
        console.log(".", t - preT);
        preT = t
      } catch (e) {
        // if we can't draw, don't bother updating anymore
        self.stop();
        console.log("!");
        throw e;
      }
    }

    self.start = function() { self.stream.start(); }
    self.stop = function() { self.stream.stop(); }
    self.setCanvas = function(canvas){setContext(canvas);}
  };

  return module;

})(MJPEG || {});

export default MJPEG;